import Client from '@/client'

export default {
  list() {
    return Client.get(`connections/`)
  },
  retrieve(id) {
    return Client.get(`connections/${id}/`)
  },
  tables(id) {
    return Client.get(`connections/${id}/tables/`)
  },
  columns(id, schema) {
    return Client.get(`connections/${id}/columns/`, { params: { table: schema } } )
  },
  versions(id) {
    return Client.get(`connections/${id}/versions/`)
  },
  scopes(id) {
    return Client.get(`connections/${id}/scopes/`)
  },
  basins(id) {
    return Client.get(`connections/${id}/basins/`)
  },
  lookup(id, file) {
    const formData = new FormData()
    formData.append('file', file)
    return Client.post(`connections/${id}/lookup/`, formData)
  },
  random(id, count = 10) {
    return Client.get(`connections/${id}/random/`, { params: { count } })
  },
  bad_wells(id, count = 10) {
    return Client.get(`connections/${id}/bad_wells/`, { params: { count } })
  },
}